import {
    type DeleteDriveFileResponseType,
    type DeleteDriveFileRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteDriveFile = async (params: DeleteDriveFileRequestType): Promise<DeleteDriveFileResponseType> => {
    return await request<DeleteDriveFileResponseType>("/drive/deleteDriveFile", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default DeleteDriveFile;
